import { GDPRSdk } from "@ciaopeople/cp-shatsu/GDPR/GDPR.js";
import { BrowserLogger, Logger } from "@ciaopeople/cp-shatsu/Logging";
import { getQSParam } from "../../../lib/utils/QueryStringUtils.js";

export interface AudicomConfig {
    /** Server App ID assegnato da Nielsen (obbligatorio) */
    appID: string;
    /** Session ID univoco per player/istanza (obbligatorio) */
    sessionID: string;
}

export interface AudicomPairingPingOptions {
    /** Endpoint base  */
    endpoint?: string;        // default audit.imrworldwide.com/cgi-bin/gn
    /** Timeout caricamento immagine */
    timeoutMs?: number;       // default 5000
    /**
     * Se true risolve anche su errore, perché il ping non ha risposta utile lato client.
     * Default: true
     */
    resolveOnError?: boolean;
}

export interface AudicomPairingPingFactory {
    /** Stream ID univoco per view/stream (obbligatorio) */
    sendPairingPing(streamID: string): Promise<void>;
}


export class AudicomPairingPing implements AudicomPairingPingFactory {
    private log = new BrowserLogger("AudicomPairingPing");

    private static BASE_URL = "https://audit.imrworldwide.com/cgi-bin/gn";
    constructor(
        private gdprPromise: Promise<GDPRSdk>,
        private audicomConfig: AudicomConfig,
        private opts: AudicomPairingPingOptions = {
            endpoint: AudicomPairingPing.BASE_URL,
            timeoutMs: 5000,
            resolveOnError: true,
        }) {
    }



    /**
     * Invia il Pairing Ping come "image tag" (GET no-preflight).
     */
    sendPairingPing(
        streamID: string,
    ): Promise<void> {

        this.log.debug("[AUDICOM] Waiting GDPR PROMISE to send Audicom Pairing Ping for streamID:", streamID);
        return this.gdprPromise.then(gdpr => {

            // TODO: verificare consenso a PAIRING PING
            // const consent = gdpr.comscore.generalEnable();
            const consent = getQSParam(window.location, "pp_consent", true);

            this.log.debug("[AUDICOM] GDPR PROMISE resolved. Consent for Audicom Pairing Ping:", consent);

            if (consent && consent == "Y") {
                const { timeoutMs, endpoint, resolveOnError } = this.opts;

                // validazioni minime richieste dalla doc
                if (!this.audicomConfig.appID) return Promise.reject(new Error("Audicom pairing ping: apid obbligatorio."));
                if (!this.audicomConfig.sessionID) return Promise.reject(new Error("Audicom pairing ping: sessionid obbligatorio."));
                if (!streamID) return Promise.reject(new Error("Audicom pairing ping: streamid obbligatorio."));

                const createtm = Math.floor(Date.now() / 1000);

                const query: Record<string, string> = {
                    apid: this.audicomConfig.appID,
                    sessionid: this.audicomConfig.sessionID,
                    streamid: streamID,
                    pingtype: "1",     // fisso come da doc
                    product: "dcr",    // fisso come da doc
                    createtm: "" + createtm,
                };

                this.log.debug("[AUDICOM] Sending Audicom Pairing Ping with params:", query);
                
                const url = `${endpoint}?${new URLSearchParams(query).toString()}`;

                // Invio via image tag
                return new Promise<void>((resolve, reject) => {
                    const img = new Image();

                    const timer = setTimeout(() => {
                        cleanup();
                        if (resolveOnError) resolve();
                        else reject(new Error(`Pairing ping timeout after ${timeoutMs}ms`));
                    }, timeoutMs);

                    function cleanup() {
                        clearTimeout(timer);
                        img.onload = null;
                        img.onerror = null;
                    }

                    img.onload = () => {
                        cleanup();
                        resolve();
                    };

                    img.onerror = () => {
                        cleanup();
                        if (resolveOnError) resolve();
                        else reject(new Error("Pairing ping failed"));
                    };

                    img.src = url;
                });

            } else {
                this.log.debug("No consent for Audicom pairing ping");
                return Promise.resolve();
            }
        });
    }

}